import { render, staticRenderFns } from "./DefaultNote.vue?vue&type=template&id=26aaf818&"
import script from "./DefaultNote.vue?vue&type=script&lang=ts&"
export * from "./DefaultNote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports